import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';

@Directive({
    selector: '[ndtRouteArea]',
    standalone: false
})
export class RouteAreaActiveDirective implements OnInit {
   @Input('ndtRouteArea')
   set area(area: string | string[] | null) {
      this._area = area;
      if (area) {
         const arr = Array.isArray(area) ? area : [area];
         this.areaTree = this.router.createUrlTree(arr);
      } else {
         this.areaTree = null;
      }
   }

   get area() {
      return this._area;
   }

   private _area: string | string[] | null = null;

   @Input('ndtRouteAreaActive')
   set className(className: string) {
      this.classes = className.split(' ');
   }

   isActive = false;

   private classes: string[] = [];

   private areaTree: UrlTree | null = null;

   constructor(private elementRef: ElementRef, private router: Router, private renderer: Renderer2) {}

   ngOnInit(): void {
      this.router.events
         .pipe(
            filter((e) => {
               return e instanceof NavigationEnd;
            }),
            startWith(null)
         )
         .subscribe(() => {
            this.update();
         });
   }

   private update(): void {
      if (!this.router.navigated) {
         return;
      }

      let areaIsActive: boolean;
      if (this.areaTree) {
         areaIsActive = this.router.isActive(this.areaTree, false);
      } else {
         areaIsActive = false;
      }

      if (this.isActive === areaIsActive) {
         return;
      }
      this.isActive = areaIsActive;
      for (const className of this.classes) {
         if (areaIsActive) {
            this.renderer.addClass(this.elementRef.nativeElement, className);
         } else {
            this.renderer.removeClass(this.elementRef.nativeElement, className);
         }
      }
   }
}
